import React from 'react';
import { Button } from '../ui/button.js';
import { FileText, X } from 'lucide-react';

interface FileTab {
  name: string;
  content: string;
  isDirty?: boolean;
}

interface OpenTabsBarProps {
  files: FileTab[];
  activeFile: string;
  onFileSelect: (fileName: string) => void;
  onFileClose?: (fileName: string) => void;
}

const OpenTabsBar: React.FC<OpenTabsBarProps> = ({
  files,
  activeFile,
  onFileSelect,
  onFileClose
}) => {
  return (
    <div className="flex gap-1 p-2 border-b border-slate-600/30 bg-slate-800/30">
      {files.map((file) => (
        <div key={file.name} className="relative group">
          <Button
            size="sm"
            variant={activeFile === file.name ? "default" : "ghost"}
            onClick={() => onFileSelect(file.name)}
            className="text-xs pr-6 hover:bg-slate-800/50"
          >
            <FileText className="h-3 w-3 mr-1" />
            {file.name}
            {file.isDirty && <span className="ml-1 text-orange-400">•</span>}
          </Button>
          {onFileClose && files.length > 1 && (
            <Button
              size="sm"
              variant="ghost"
              onClick={(e) => {
                e.stopPropagation();
                onFileClose(file.name);
              }}
              className="absolute right-0 top-0 h-full w-5 p-0 opacity-0 group-hover:opacity-100 transition-opacity hover:bg-slate-700/50"
            >
              <X className="h-3 w-3" />
            </Button>
          )}
        </div>
      ))}
    </div>
  );
};

export default OpenTabsBar;
